import type { ChiTietGiayBaoCo, GiayBaoCoInvoiceLookup } from '@/types/schemas/giay-bao-co.type';
import type { TableSelectedCell } from '@/components/custom/erp';
import { useTableRows } from '@/components/custom/erp';

export type SelectedCellInfo = TableSelectedCell;

export interface DetailItemRow extends ChiTietGiayBaoCo {
  uuid: string;
  id_hd_data?: {
    tien_hd_nt?: string | number;
    cl_nt?: string | number;
    t_tien_nt?: string | number;
  } & GiayBaoCoInvoiceLookup;
}

type DetailItemRowInput = Omit<DetailItemRow, 'uuid'> & { uuid?: string | null };

const normalizeInitialRows = (rows: DetailItemRowInput[] = []): DetailItemRow[] =>
  rows.map((row, index) => ({
    ...row,
    uuid: row.uuid && row.uuid !== '' ? row.uuid : `temp-${Date.now()}-${index}`
  })) as DetailItemRow[];

export function useDetailItemRows(initialRows: DetailItemRowInput[] = []) {
  const {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handleMoveRow,
    handlePasteRow,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  } = useTableRows<DetailItemRow>({
    initialRows: normalizeInitialRows(initialRows),
    defaultRows: 1,
    defaultField: 'dien_giai',
    onFieldValueChange: (_, field, newValue) => {
      if (field === 'id_hd_data' && newValue) {
        const tien_nt = newValue.tien_hd_nt || newValue.cl_nt || newValue.t_tien_nt || 0;
        return { tien_nt };
      }

      return {};
    }
  });

  return {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  };
}
